(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shopable_video"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()

    

    setTimeout(() => {
      const slider = new window.Swiper(this.querySelector('.swiper'), this.splideOptions())

      slider.on('slideChange', () => {
        this.querySelector('.swiper').classList.add('swiper-is-changing')
        this.onSlideChange()
      })

      slider.on('slideChangeTransitionEnd', () => {
        this.querySelector('.swiper').classList.remove('swiper-is-changing')
      })
    }, 500)

    this.querySelectorAll('.ks-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const card = btn.closest('.ks-shoppable-videos-card')
        this.openReels(parseInt(card.dataset.index, 10))
      })
    })

    this.querySelectorAll('.ks-shoppable-videos-card video').forEach(video => {
      video.addEventListener('click', () => {
        const card = video.closest('.ks-shoppable-videos-card')
        this.openReels(parseInt(card.dataset.index, 10))
      })
    })

    this.initReels()

    const lazyVideosObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.play()
        }
      })
    }, { rootMargin: '0px 0px 300px 0px' })
    
    this.querySelectorAll('video[data-autoplay="true"]').forEach((el) => {
      lazyVideosObserver.observe(el)
    })
  }

  splideOptions () {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    /** @type {SwiperOptions} */
    const options = {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      spaceBetween: 0,
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true 
        // hide: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true, 
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
    }
    return options
  }

  

  onVideoPlay (video) {
    const card = video.closest('.ks-shoppable-videos-card')

    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      if (elem.dataset.index !== card.dataset.index) {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      }
    })
    
    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      video.muted = false
      video.play()
    }
  }

  initReels () {
    this.reelsModal = this.querySelector('.ks-reels-modal')
    if (!this.reelsModal) return
    this.reelsScroller = this.reelsModal.querySelector('[data-scroller]')
    this.reelsMuted = true

    this.reelsModal.querySelector('[data-close-btn]').addEventListener('click', () => this.closeReels())
    this.reelsModal.querySelector('[data-mute-btn]').addEventListener('click', () => this.toggleReelsMute())

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.reelsModal.hasAttribute('open')) this.closeReels()
    })

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const vid = entry.target.querySelector('video')
        if (!vid) return
        if (entry.isIntersecting && entry.intersectionRatio > 0.6) {
          vid.muted = this.reelsMuted
          vid.play().catch(() => {})
        } else {
          vid.pause()
        }
      })
    }, { threshold: [0, 0.6, 1] })

    this.reelsModal.querySelectorAll('.ks-reels-modal__item').forEach(item => observer.observe(item))
  }

  openReels (index) {
    if (!this.reelsModal) return
    this.reelsModal.setAttribute('open', '')
    this.reelsModal.setAttribute('aria-hidden', 'false')
    document.body.classList.add('ks-reels-open')

    this.querySelectorAll('.ks-shoppable-videos-card video').forEach(v => v.pause())

    const target = this.reelsScroller.querySelector(`.ks-reels-modal__item[data-index="${index}"]`)
    if (target) {
      this.reelsScroller.scrollTo({ top: target.offsetTop, behavior: 'instant' in window ? 'instant' : 'auto' })
    }
  }

  closeReels () {
    if (!this.reelsModal) return
    this.reelsModal.removeAttribute('open')
    this.reelsModal.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('ks-reels-open')
    this.reelsModal.querySelectorAll('video').forEach(v => v.pause())
  }

  toggleReelsMute () {
    this.reelsMuted = !this.reelsMuted
    this.reelsModal.querySelectorAll('video').forEach(v => { v.muted = this.reelsMuted })
  }

}
customElements.define('ks-shoppable-videos', KsShoppableVideos)


  } catch(e) { console.error(e); }
})();
})();
